module.exports = __webpack_public_path__ + "static/media/7.1040bd38.jpg";